import { tx as translateInterfaceText } from '@/utils/i18n';
import { useLanguage } from '@/hooks/useLanguage';
import React, { useEffect, useState } from 'react';
import { Drawer } from 'vaul';
import { ScrollArea } from '@/components/ui/scroll-area';
import { PlanUsageSectionMobile } from '../sidebar/PlanUsageSectionMobile';
import { PlaysManagementModal } from '../sidebar/PlaysManagementModal';
import { useTheme } from '@/contexts/ThemeContext';

interface MobileDrawerProps {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
  customLayout?: boolean; // Usado para personalização/new-video
}

export function MobileDrawer({ isOpen, onClose, children, customLayout = false }: MobileDrawerProps) {
  useLanguage();
  const { resolvedTheme } = useTheme();
  const isDark = resolvedTheme === 'dark';
  const [isPlaysModalOpen, setIsPlaysModalOpen] = useState(false);

  const handleOpenPlaysModal = () => {
    setIsPlaysModalOpen(true);
  };

  // Bloquear scroll do body quando menu aberto
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
      document.body.style.height = '100vh';
    } else {
      document.body.style.overflow = 'auto';
      document.body.style.height = 'auto';
    }
    
    return () => {
      document.body.style.overflow = 'auto';
      document.body.style.height = 'auto';
    };
  }, [isOpen]);
  
  return (
    <Drawer.Root 
      open={isOpen} 
      onOpenChange={(open) => !open && onClose()}
      direction="left"
      modal={true}
    >
      <Drawer.Portal>
        <Drawer.Overlay className="fixed inset-0 z-[9998] bg-black/45 backdrop-blur-[6px]" />
        <Drawer.Content 
          className="fixed left-0 top-0 bottom-0 z-[9999] flex flex-col"
          style={{
            width: '280px',
            maxWidth: '75%',
            background: 'hsl(var(--card))',
            color: 'hsl(var(--foreground))',
            boxShadow: '0 0 30px rgba(0,0,0,0.32)',
            transition: 'transform 0.28s cubic-bezier(0.22, 1, 0.36, 1)'
          }}
        >
          {customLayout ? (
            // Layout personalizado para personalização/new-video
            <div className="h-full flex flex-col">
              {children}
            </div>
          ) : (
            // Layout padrão do dashboard
            <>
              {/* HEADER FIXO */}
              <div className="px-5 flex-shrink-0 flex flex-row items-center" style={{ height: '52px' }}>
                <img
                  src="/assets/imgs/logo-azul-e-preta.png"
                  alt={translateInterfaceText("HostVSL")}
                  className="h-6"
                />
              </div>

              {/* ÁREA ROLÁVEL COM SCROLLBAR AZUL - Padding reduzido */}
              <ScrollArea className="flex-1" style={{
                scrollbarWidth: 'thin',
                scrollbarColor: 'var(--primary) transparent',
                maxHeight: 'calc(100vh - 180px)'
              }}>
                <div style={{ padding: '16px 20px' }}>
                  {children}
                </div>
              </ScrollArea>

              {/* DIVISÓRIA */}
              <div className="flex-shrink-0" style={{ height: '1px', background: isDark ? 'rgba(255,255,255,0.06)' : 'rgba(0,0,0,0.06)' }} />

              {/* RODAPÉ FIXO COM SAFE AREA */}
              <div className="px-4 py-4 flex-shrink-0 pb-[calc(16px+env(safe-area-inset-bottom))]">
                <PlanUsageSectionMobile onAddPlaysClick={handleOpenPlaysModal} />
              </div>
            </>
          )}
        </Drawer.Content>
      </Drawer.Portal>

      {/* Modal de Compra de Plays */}
      <PlaysManagementModal open={isPlaysModalOpen} onOpenChange={setIsPlaysModalOpen} />
    </Drawer.Root>
  );
}
